<template>
  <div class="ChooseRequestType">
    <div class="heading">{{ content.heading }}</div>
    <div class="prompt">{{ content.prompt }}</div>
    <button class="button" @click="salesChosen()">{{ content.sales }}</button>
    <button class="button" @click="supportChosen()">{{ content.support }}</button>
  </div>
</template>

<script>
import { pushAnalyticsEvent } from '~/lib/analyticsEvents.js'

import strings from './strings.json'
export default {
  props: {
    selectSales: Function,
    hidePopup: Function,
  },
  inject: ['locale'],
  computed: {
    content() {
      return strings[this.locale].requestType
    },
  },
  methods: {
    salesChosen() {
      this.selectSales()
      pushAnalyticsEvent({
        scope: 'multichoicePromoPopup',
        action: 'salesRequest',
        content: this.content,
      })
    },
    supportChosen() {
      this.$pageActions.dispatch('showSupportWizardForm', this.content.support)
      this.hidePopup()
      pushAnalyticsEvent({
        scope: 'multichoicePromoPopup',
        action: 'supportRequest',
        content: this.content,
      })
    },
  },
}
</script>

<style scoped>

.heading {
  font-weight: 600;
  font-size: var(--font-size-3);
  color: var(--text-color-black);
}

.prompt {
  margin-top: var(--spacing-4);
  font-weight: 500;
  font-size: var(--font-size-2);
  color: var(--text-color-black);
}

.button {

  margin-top: var(--spacing-6);

  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  column-gap: var(--spacing-5);

  padding: var(--spacing-4) var(--spacing-5);
  border: thin solid #e9e9e9;
  border-radius: 8px;

  text-align: left;
  font-weight: 500;
  font-size: var(--font-size-2);
  color: var(--text-color-black);
}

.button:hover {
  background-color: #f9f9f9;
}

.button::before {
  content: '';
  display: block;
  border: thin solid #acacac;
  border-radius: 999px;
  width: 21px;
  height: 21px;
}
</style>
